export default __webpack_public_path__ + "static/media/2017outback.b53806f0.jpg";